const dataGridData = (data) => {
  const rows = data.map((dt) => {
    return {
      id: dt.id,
      dataCriacao: dt.dataCriacao,
      dataLimitePagamento: dt.dataLimitePagamento,
      dataPagamento: dt.dataPagamento,
      valor: `${dt.valor.toLocaleString("pt-BR")}$00`,
      valorOriginal: dt.valor,
      tipo: dt.tipo,
      estado: dt.estado,
      metodoPagamento: dt.metodoPagamento,
      despesaPaga: dt.despesaPaga,
      descricao: dt.descricao,
      comprovativo: dt.comprovativo,
      caixa: dt.caixa,
      // A unidade da despesa: a pastilha e o bloqueio das ações leem daqui.
      // Esta função reconstrói a linha campo a campo — o que não estiver
      // listado é deitado fora em silêncio, por muito que exista na origem.
      estabelecimento: dt.estabelecimento,
      categoria: dt.categoria,
      nrOrdemPagamento: dt.nrOrdemPagamento,
      banco: dt.banco,
      nrContaCliente: dt.nrContaCliente,
      nrCheque: dt.nrCheque,
      dataCheque: dt.dataCheque,
      fornecedor: dt.fornecedor,
      cliente: dt.cliente,
      funcionario: dt.funcionario,
      funcionarioUser: dt.funcionarioUser,
    };
  });

  return rows;
};

export default dataGridData;
